module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Subscribe to our Newsletter")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "newsletter"
    }
  }, [(_vm.show) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "type your email here"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Subscribe")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Our Credo")]), _vm._v(" "), _c('p', [_vm._v("If quality comes at a price, why does Apollo come handy? \n\t\t"), _c('br'), _c('br'), _vm._v("Because Apollo understands Because Apollo believes that suiting your senses is as important as suiting your mind.\n\t\t"), _c('br'), _c('br'), _vm._v("Because as Apollo meets your needs, so is its purpose.\n\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item col-md-4 col-xs-12"
  }, [_c('h2', [_vm._v("Contact Info")]), _vm._v(" "), _c('p', [_vm._v("Mutual Success Lighting Fixtures Inc.\n\t\t"), _c('br'), _vm._v("Suite 3003-A East Tower, PSE Center, Exchange Road, \n\t\t"), _c('br'), _vm._v("Ortigas Center, Pasig City\n\t\t"), _c('br'), _c('br'), _vm._v("\n\t\tLandline # (632) 687-7111\n\t\t"), _c('br'), _vm._v("Fax # (632) 687-7111 loc 5\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c12a21ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 163
// module chunks = 0